import Recat from "react";
import classNames from "classnames";

import { Spin as Hamburger } from "hamburger-react";

export default Hamburger;
